import DateFilter from '@/components/date-filter';
import DetailDMP from '@/components/comptable/dashboard/tab-dmp/dmp-detail'
import store_dmp from "@/store/mods/clinique/patients"
import $ from 'jquery'

export default {
    name: 'tab-dmp',
    components: {
        DateFilter, DetailDMP
    },
    props: {
        liste_personnel_roles: Array
    },

    data() {
        return {
            compte_id: 1,
            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            is_month: false,
            personnel_id: "",
            personnel: '',
            stat_loading: false,
            is_error: false,
            dmp_stats: {},
            modal_title: '',
            patients: [],
            modal_toggler: 0,
            excel_filename: '',
            is_patient: 0
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            this.operations_tobe_canceled = []
            this.current_date_filter = {
                user_id: this.personnel_id,
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: "",
                from_hour: "",
                to_hour: "",
            }
            this.is_month = true
            this.getDMPStats(this.current_date_filter)
        },

        personnel() {
            this.personnel_id = this.personnel.id

            this.current_date_filter.user_id = this.personnel_id
            this.getDMPStats(this.current_date_filter)
        },
    },

    computed: {
        
    },

    mounted() {
        this.curr_month = this.monthOfYear[this.current_date.getMonth()+1]

        // this.current_date_filter = {
        //     user_id: "",
        //     month: "",
        //     one_date: this.setDates().today_date,
        //     from_date: "",
        //     to_date: "",
        //     from_hour: "",
        //     to_hour: "",
        // }
        // this.getDMPStats(this.current_date_filter)
    },

    methods: {
        filterByDate(date) {
            this.current_date_filter = {
                user_id: this.personnel_id,
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour,
            }
            this.filter_date = ""

            this.is_month = false
            this.getDMPStats(this.current_date_filter)
        },

        getDMPStats(data) {
            this.stat_loading = true

            store_dmp.getStatsDMP(data).then((stats) => {
                console.log("STATS: ",stats);
                this.dmp_stats = stats

                this.stat_loading = false
            }).catch(() => {
                this.is_error = true
                this.stat_loading = false
            })
        },

        viewDetailDMP(data, data_type) {
            this.modal_toggler = (this.modal_toggler == 0)?1:0

            this.modal_title = this.setDataType(data_type)
            this.patients = data

            setTimeout(() => {
                $('.view-dmp-detail').modal('show')
            }, 500);
        },

        viewConsultationPatient(data, data_type) {
            console.log(">> ",data);
            this.modal_toggler = (this.modal_toggler == 0)?1:0

            this.modal_title = this.setDataType(data_type)
            this.patients = data

            setTimeout(() => {
                $('.view-consultation-patient').modal('show')
            }, 500);
        },

        setDataType(slug) {
            let data_type = ''

            let period = ''
            if (this.is_month) {
                period = 'du mois de '+this.curr_month.lib
            } else {
                if (this.current_date_filter.one_date != '') {
                    period = 'du '+this.formatDateToDmY(this.current_date_filter.one_date)
                } else {
                    period = 'du '+this.formatDateToDmY(this.current_date_filter.from_date)+' au '+this.formatDateToDmY(this.current_date_filter.to_date)
                }
            }

            switch (slug) {
                case 'g_patients':
                    data_type = 'Tous les patients'
                    this.is_patient = 1
                    break
                case 'g_consultations':
                    data_type = 'Toutes les consultations'
                    this.is_patient = 0
                    break
                case 'g_new_consultations':
                    data_type = 'Toutes les nouvelles consultations'
                    this.is_patient = 1
                    break
                case 'tot_recap_patients':
                    data_type = 'Tous les patients '+period
                    this.is_patient = 1
                    break
                case 'tot_recap_consultations':
                    data_type = 'Toutes les consultations '+period
                    this.is_patient = 0
                    break
                case 'tot_recap_new_consultations':
                    data_type = 'Toutes les nouvelles consultations '+period
                    this.is_patient = 1
                    break
                case 'tot_recap_patient_hommes':
                    data_type = 'Tous les patients hommes '+period
                    this.is_patient = 1
                    break
                case 'tot_recap_patient_femmes':
                    data_type = 'Tous les patients femmes '+period
                    this.is_patient = 1
                    break
                case 'tot_recap_patient_enfants':
                    data_type = 'Tous les enfants de moins de 5ans '+period
                    this.is_patient = 1
                    break
                case 'recap_consultation_hommes':
                    data_type = 'Consultations hommes '+period
                    this.is_patient = 0
                    break
                case 'recap_consultation_femmes':
                    data_type = 'Consultations femmes '+period
                    this.is_patient = 0
                    break
                case 'recap_consultation_moins_5_ans':
                    data_type = 'Consultations enfants de moins de 5ans '+period
                    this.is_patient = 0
                    break
                case 'new_consultation_hommes':
                    data_type = 'Nouvelles consultations hommes '+period
                    this.is_patient = 1
                    break
                case 'new_consultation_femmes':
                    data_type = 'Nouvelles consultations femmes '+period
                    this.is_patient = 1
                    break
                case 'new_consultation_moins_5_ans':
                    data_type = 'Nouvelles consultations enfants de moins de 5ans '+period
                    this.is_patient = 1
                    break
            }
            return data_type
        }
    }
}